import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import './slidePreview.scss'


const SlidePreview = ({
  backgroundImage,
  title,
  className,
}) => (
  <div className={cn('thumbnail', className)}>
    <div
      className="preview-item"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    />
    <div className="preview-title">
      {title}
    </div>
  </div>
)

SlidePreview.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default SlidePreview
